const currentUserRoles = (currentUserRoles = [], action) => {
  switch (action.type) {
    case 'FETCH_CURRENT_USER_ROLES':
      return action.payload
    default:
      return currentUserRoles
  }
}
export default currentUserRoles
